<rdo-breadcrumb></rdo-breadcrumb>
<div id="rental-asset" [rdoFillRemainingHeight]>
  <div class="d-flex flex-row position-relative align-items-stretch scroll-container" [rdoCollapsedCards]="'product-type'">

    <rdo-collapsible [key]="'rental-asset'">
      <div class="rdo-col-card-fixed scroll"
        infinite-scroll
        [infiniteScrollThrottle]="500"
        (scrolled)="getPaginatedCards()"
        [scrollWindow]="false">
        <div class="rdo-card-list">
          @for (c of assetCards; track c) {
            <rdo-nav-card-asset
              [data]="c"
              [selected]="isSelected(c)"
              [icon]="'fa-tags'"
              (selectedChange)="select(c)"
              [rdo-scroll-into]="isSelected(c)"
              />
          }

        </div>
      </div>
    </rdo-collapsible>
    <div class="rdo-col-card-offset container-fluid scroll-container collapsible-offset">
      <div class="row">
        <div class="col-12">
          <h3>
            <i class="fa fa-tags"></i>
            {{selectedAsset?.ModelYear}} {{selectedAsset?.Make}} {{selectedAsset?.Model}}
          </h3>
        </div>
      </div>
      <div class="row margin-bottom-xl">
        <div class="col-12">
          <ul class="nav nav-pills rdo-nav-pills">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <a class="nav-link" [routerLink]="['./']">{{'main.core.common.dashboard' | translate}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" id="rental-asset-content">
        <div class="scroll-container">
          <div class="col-12 scroll active">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
